import { Pipe, PipeTransform } from '@angular/core';
import { Upa } from '../../uas/ua.model';

@Pipe({
  name: 'upaIsMissingTranslations'
})
export class UpaIsMissingTranslationsPipe implements PipeTransform {

  transform(upa: Upa, languageCode: string, fieldName: string): boolean {
    switch (fieldName) {
      case 'headline':
        return !upa.translations[languageCode]?.headline;
      case 'description':
        return !upa.translations[languageCode]?.description;
      case 'formattedDescription':
        return !upa.translations[languageCode]?.description_md;
      case 'caption':
        return this.isMissingCaption(upa, languageCode, 'caption');
      case 'formattedCaption':
        return this.isMissingCaption(upa, languageCode, 'caption_md');
    }
    return false;
  }
  
  private isMissingCaption(upa: Upa, languageCode: string, fieldName: 'caption' | 'caption_md'): boolean {
    if (upa.photo_count > 0 && upa.photos.some(photo => !photo[fieldName][languageCode])) {
      return true;
    };
    if (upa.video_count > 0 && upa.videos.some(video => !video[fieldName][languageCode])) {
      return true;
    }
    if (upa.tour_count > 0 && upa.tours.some(tour => !tour[fieldName][languageCode])) {
      return true;
    }
    return false;
  }

}